import { createFileRoute, redirect } from '@tanstack/react-router';

// Shared code lives in the Library now (automation §16); old links keep working.
export const Route = createFileRoute('/_shell/transforms/')({
  beforeLoad: () => {
    throw redirect({ to: '/library', search: { view: 'code' }, replace: true });
  },
});
